/***
 * Events indicating that some part of the model state were automatically changed in favour of satisfying all constraints.
 */
import { PModel, PropertyPath } from '../../engine.js';
import { EngineNotificationsService } from './EngineNotificationsService.js';
import { eventUtils } from '../EventUtils.js';
import { ModelNotificationEvent } from './ModelNotificationEvent.js';


export class AutoCorrectPropertyEvent<T> extends ModelNotificationEvent {
  constructor(public readonly target: PModel, public readonly propertyPath: PropertyPath, public readonly oldValue: T, public readonly newValue: T) {
    super(target);
  }
}

export type AutoCorrectListener<T> = (event: AutoCorrectPropertyEvent<T>) => void;

export class AutoCorrectModelEvents {
  constructor(private notifications: EngineNotificationsService) {
  }

  public propertiesAutoCorrected<T>(listener: AutoCorrectListener<T>) {
    this.notifications.subscribe('AutoCorrectProperty', listener);
  }

  public propertyAutoCorrected<T>(propertyPath: PropertyPath, listener: AutoCorrectListener<T>) {
    this.notifications.subscribe('AutoCorrectProperty', eventUtils.filter(listener, event => event.propertyPath === propertyPath));
  }
}
